import { createFileRoute } from "@tanstack/react-router";
import { TikTokBioPage } from "../pages/TikTokBioPage";
import { site } from "../config/site";

const title = "TikTok Bio Maker - Aesthetic TikTok Bios to Copy and Paste";
const description = "Find TikTok bio ideas or start with your own text. Create an aesthetic TikTok bio with fonts, templates, and symbols, then preview, edit, and copy.";
const canonical = `${site.origin}/tiktok-bio/`;

export const Route = createFileRoute("/tiktok-bio")({
  head: () => ({
    meta: [
      { title },
      { name: "description", content: description },
      { property: "og:title", content: title },
      { property: "og:description", content: description },
      { property: "og:type", content: "website" },
      { property: "og:url", content: canonical },
      { property: "og:locale", content: "en_US" },
      { name: "twitter:card", content: "summary" },
      { name: "twitter:title", content: title },
      { name: "twitter:description", content: description },
    ],
    links: [{ rel: "canonical", href: canonical }],
  }),
  component: TikTokBioPage,
});
